import request from './request'
import API from './api'
import objToFormData from '@/utils/obj-to-formdata'

export const reqGetEncodeInfo = (encode) => {
  return request({
    url: API.getEncodeInfo,
    params: {
      encode
    }
  })
}

export const reqCheck = (encode) => {
  return request({
    url: API.check,
    params: {
      encode
    },
    isShowErrorTip: false
  })
}

export const reqGetDataList = (dataType) => {
  return request({
    url: API.getDataList + dataType + '/' + process.env.VUE_APP_COMPANY_ID,
    isRejectError: false
  })
}

export const reqActivation = (data) => {
  return request({
    method: 'POST',
    url: API.activation,
    data: objToFormData(data),
  })
}
